import React, { useEffect, useState } from "react";
import {
  Package,
  // Users,
  Newspaper,
  Mail,
  // Image as ImageIcon,
  Layers,
  Tag,
} from "lucide-react";
import { getContacts } from "../../../services/admin/contact";
import { getNewsUpdates } from "../../../services/newsupdates";
// import { getMedia } from "../../../services/admin/media";
import { getProduct } from "../../../services/admin/product";
import { getCategory } from "../../../services/admin/category";
import { getBrands } from "../../../services/admin/brand";

const AdminDashboard = () => {
  const [contactCount, setContactCount] = useState(0);
  const [newsCount, setNewsCount] = useState(0);
  // const [mediaCount, setMediaCount] = useState(0);
  const [productCount, setProductCount] = useState(0);
  const [categoryCount, setCategoryCount] = useState(0);
  const [brandCount, setBrandCount] = useState(0);

  useEffect(() => {
    fetchCounts();
  }, []);

  const fetchCounts = async () => {
    const contacts = await getContacts();
    if (contacts.success) setContactCount(contacts.data.length);

    const news = await getNewsUpdates();
    if (news.success) setNewsCount(news.data.length);

    // const media = await getMedia();
    // if (media.success) setMediaCount(media.data.length);

    const product = await getProduct();
    if (product.success) setProductCount(product.data.length);

    const categories = await getCategory();
    if (categories.success) setCategoryCount(categories.data.length);

    const brands = await getBrands();
    if (brands.success) setBrandCount(brands.data.length);
  };

  const cardData = [
    {
      title: "Total Products",
      value: `${productCount}`,
      icon: <Package className="w-6 h-6 text-white" />,
      bgColor: "from-blue-500 to-blue-700",
    },
    {
      title: "News & Updates",
      value: `${newsCount}`,
      icon: <Newspaper className="w-6 h-6 text-white" />,
      bgColor: "from-yellow-400 to-yellow-600",
    },
    // {
    //   title: "Total Images",
    //   value: `${mediaCount}`,
    //   icon: <ImageIcon className="w-6 h-6 text-white" />,
    //   bgColor: "from-pink-500 to-pink-700",
    // },
    {
      title: "Contact Forms",
      value: `${contactCount}`,
      icon: <Mail className="w-6 h-6 text-white" />,
      bgColor: "from-purple-500 to-purple-700",
    },
    {
      title: "Total Categories",
      value: `${categoryCount}`,
      icon: <Layers className="w-6 h-6 text-white" />,
      bgColor: "from-green-500 to-green-700",
    },
    {
      title: "Total Brands",
      value: `${brandCount}`,
      icon: <Tag className="w-6 h-6 text-white" />,
      bgColor: "from-red-500 to-red-700",
    },
  ];

  return (
    <div className="p-6 space-y-6">
      <h1 className="text-2xl font-semibold text-gray-800">Dashboard</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {cardData.map((card, index) => (
          <DashboardCard key={index} {...card} />
        ))}
      </div>
    </div>
  );
};

interface DashboardCardProps {
  title: string;
  value: string;
  icon: React.ReactNode;
  bgColor: string;
}

const DashboardCard: React.FC<DashboardCardProps> = ({
  title,
  value,
  icon,
  bgColor,
}) => {
  return (
    <div
      className="group flex items-center justify-between p-5 rounded-2xl bg-white border border-gray-100 shadow-md hover:shadow-xl transition-all duration-300 ease-in-out transform hover:-translate-y-1"
    >
      <div>
        <p className="text-sm font-medium text-gray-500">{title}</p>
        <h3 className="text-3xl font-extrabold text-gray-800 group-hover:text-blue-600 transition-colors duration-300">
          {value}
        </h3>
      </div>
      <div
        className={`p-3 rounded-full bg-gradient-to-br ${bgColor} text-white shadow-lg group-hover:scale-110 transform transition-transform duration-300`}
      >
        {icon}
      </div>
    </div>
  );
};

export default AdminDashboard;
